// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x0YWk","footer":"styles_footer__42_z6"};